<template>
  <div id="HomeContent" class="min-h-screen overflow-x-hidden bg-[#f5f2ec] text-[#1f2826]">
    <navbar id="navbar" />
    <main>
      <home-content id="home" />
      <features id="features"></features>
      <about id="about"></about>
      <projects id="projects"></projects>
      <section id="walkthrough" class="bg-[#1f2826] px-4 py-10 text-[#f7f2e8] sm:px-5 md:py-28">
        <div class="mx-auto max-w-7xl">
          <div class="mb-6 grid gap-4 md:mb-10 md:grid-cols-[0.8fr_1.2fr] md:items-end md:gap-8">
            <div>
              <p class="section-kicker text-[#c7b78f]">Immersive Review</p>
              <h2 class="mt-3 font-serif text-3xl leading-tight sm:text-4xl md:text-5xl">
                Experience spaces before they are built.
              </h2>
            </div>
            <p class="text-base leading-7 text-white/70 md:text-lg md:leading-8">
              Explore design intent through an interactive 3D view, useful for
              understanding scale, finishes, light, and spatial flow with better
              clarity before construction decisions are made.
            </p>
          </div>

          <div class="image-surface h-[320px] bg-black sm:h-[420px] md:h-[70vh]">
            <ArtboxIframe></ArtboxIframe>
          </div>

          <router-link
            :to="{ name: '3dview' }"
            class="mt-6 inline-flex rounded-full border border-white/40 px-5 py-3 text-sm font-semibold uppercase tracking-[0.14em] text-white transition hover:bg-white hover:text-[#1f2826] md:mt-8 md:px-6 md:tracking-[0.18em]"
          >
            View Fullscreen
          </router-link>
        </div>
      </section>
      <ContactUs id="contact_us"></ContactUs>
    </main>
    <Footer></Footer>

    <div class="fixed bottom-5 right-5 z-[9999] flex flex-col gap-3 sm:flex-row">
      <a
        class="relative isolate flex h-12 w-12 items-center justify-center rounded-full bg-[#1f8f56] text-white shadow-[0_14px_30px_rgba(31,40,38,0.2)] ring-1 ring-white/60 transition hover:-translate-y-0.5"
        target="_blank"
        rel="noopener"
        aria-label="WhatsApp"
        href="https://wa.me/+919567746540"
      >
        <i class="fab fa-whatsapp relative z-10 text-xl leading-none"></i>
      </a>
      <a
        class="relative isolate flex h-12 w-12 items-center justify-center rounded-full bg-[#9d3f72] text-white shadow-[0_14px_30px_rgba(31,40,38,0.2)] ring-1 ring-white/60 transition hover:-translate-y-0.5"
        target="_blank"
        rel="noopener"
        aria-label="Instagram"
        href="https://www.instagram.com/phosphene.architects?igshid=czZidzRzZXpkNmN2"
      >
        <i class="fab fa-instagram relative z-10 text-xl leading-none"></i>
      </a>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navbar.vue";
import HomeContent from "../components/HomeContent.vue";
import About from "../components/about.vue";
import Projects from "../components/projects.vue";
import ContactUs from "@/components/ContactUs.vue";
import Footer from "../components/Footer.vue";
import ArtboxIframe from "@/components/ArtboxIframe.vue";
import Features from "@/components/features.vue";
export default {
  components: {
    Navbar,
    HomeContent,
    About,
    Projects,
    Features,
    ContactUs,
    Footer,
    ArtboxIframe
  },
};
</script>

<style lang="scss" scoped>
</style>
